<template>
    <div class="payment-token-list btn-list"
         :class="{ 'selectable-btns': selectable }">
        <button v-for="token in paymentTokens"
                :key="token.ID"
                class="btn btn-lg btn-block btn-white"
                :class="{ active: selectedPaymentToken && token.ID === selectedPaymentToken.ID }"
                @click="click(token)">
            <span class="break-wrap">{{ token.reference }}</span>
            <small>{{ l('PAYMENT.TOKEN_UPDATED_AT') }} {{ dateFilter(token.effectiveFrom) }}</small>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        /**
         * @type {PaymentToken[]}
         */
        paymentTokens: {
            type: Array,
            required: true,
        },

        /**
         * @type {?PaymentToken}
         */
        selectedPaymentToken: {
            type: Object,
            default: null,
        },

        selectable: {
            type: Boolean,
            default: false,
        },
    },

    emits: [
        'update:selectedPaymentToken',
    ],

    methods: {
        click(paymentToken) {
            if (this.selectable) {
                if (this.selectedPaymentToken === paymentToken) {
                    // Clicking the already selected payment token deselects it.
                    this.$emit('update:selectedPaymentToken', null);
                } else {
                    this.$emit('update:selectedPaymentToken', paymentToken);
                }
            }
        },
    },
};
</script>
